import { action, makeObservable } from "mobx";
import { FunctionComponent, SyntheticEvent } from "react";
import CustomViewDialogStore from "../CustomViewDialogStore";
import { ICustomViewDataSheetTableOptions, ICustomViewTableDropDownOptions } from "./CustomViewOptions";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

/**
 * This store contains information about data sheet table options
 */
class DataSheetTableOptionsStore<T extends ICustomViewDataSheetTableOptions = ICustomViewDataSheetTableOptions> extends TableCustomViewOptionsStore<T> {
	constructor(
		tableDropDownOptions: ICustomViewTableDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: T,
	) {
		super(tableDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
	}

	/** set the value for displayCommentLines */
	@action setDisplayCommentLines = (event: SyntheticEvent, value: boolean): void => {
		this.options.displayCommentLines = value;
	};
}

export = DataSheetTableOptionsStore;